// TEMP: Hapus setelah pergantian Division Head HSE resmi
import moment from "moment";

/**
 * Jadwal nama Division Head HSE.
 * Urutkan dari tanggal terlama ke terbaru.
 *
 * Untuk pergantian berikutnya, cukup tambah baris baru di bawah:
 * { effectiveFrom: "YYYY-MM-DD", name: "Nama Baru", title: "Jabatan" }
 *
 * Entri yang berlaku = entri terakhir yang effectiveFrom <= tanggal referensi.
 */
const DIVISION_HEAD_HSE_SCHEDULE = [
  {
    effectiveFrom: "2022-01-01",
    name: "Bpk. Supandi",
    title: "Division Head HSE",
  },
  {
    effectiveFrom: "2026-08-17",
    name: "Bpk. Yudha HES",
    title: "Division Head HSE",
  },
];

function getActiveDivisionHeadHseEntry(referenceDate = new Date()) {
  const date = moment(referenceDate).startOf("day");
  let activeEntry = DIVISION_HEAD_HSE_SCHEDULE[0];

  for (const entry of DIVISION_HEAD_HSE_SCHEDULE) {
    const effectiveDate = moment(entry.effectiveFrom, "YYYY-MM-DD").startOf(
      "day",
    );
    if (!date.isBefore(effectiveDate)) {
      activeEntry = entry;
    }
  }

  return activeEntry;
}

/**
 * Mengembalikan nama Division Head HSE berdasarkan tanggal referensi.
 * @param {Date|string|moment.Moment} [referenceDate=new Date()]
 */
export function getDivisionHeadHSEName(referenceDate = new Date()) {
  return getActiveDivisionHeadHseEntry(referenceDate).name;
}

/**
 * Mengembalikan jabatan Division Head HSE berdasarkan tanggal referensi.
 * @param {Date|string|moment.Moment} [referenceDate=new Date()]
 */
export function getDivisionHeadHSETitle(referenceDate = new Date()) {
  return getActiveDivisionHeadHseEntry(referenceDate).title;
}
